import {
  CpsUiAdminConfigType,
  CpsUiAdminConfigWriteType,
  CpsUiAdminConfigState,
  CpsHelpCenterState,
  CPS_UI_ADMIN_CONFIG_TYPE
} from '@cs-cms/types';
import { createContext, useContext } from 'react';

interface IUiAdminConfigsContext {
  refreshUiAdminConfigState: (configKey: CpsUiAdminConfigType) => void;
  setConfigWritePermissionsKeys?: (writeKeys: CpsUiAdminConfigType[]) => void;
  isLoading: boolean;
  upsertUiAdminConfigEntry: (key: CpsUiAdminConfigType, body: string) => void;
  uiAdminConfigWritePermissions?: CpsUiAdminConfigWriteType;
  uiAdminConfigPreviewState: CpsUiAdminConfigState;
  setUiAdminConfigPreviewState?: (messageBarPreview: CpsUiAdminConfigState) => void;
  resetPreviewState: () => void;
  uiAdminConfigState: CpsUiAdminConfigState;
  tempHelpCenterState?: Partial<CpsHelpCenterState>;
  setTempHelpCenterState: (tempHelpCenterState: Partial<CpsHelpCenterState>) => void;
}

export const UiAdminConfigsContext = createContext<IUiAdminConfigsContext>({
  isLoading: false,
  upsertUiAdminConfigEntry: () => {},
  uiAdminConfigPreviewState: {
    [CPS_UI_ADMIN_CONFIG_TYPE.MESSAGE_BAR]: undefined,
    [CPS_UI_ADMIN_CONFIG_TYPE.MAINTENANCE_PAGE]: undefined
  },
  uiAdminConfigState: {},
  resetPreviewState: () => {},
  refreshUiAdminConfigState: () => {},
  setTempHelpCenterState: () => {}
});

export const useUiAdminConfigsContext = () => useContext(UiAdminConfigsContext);
